import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
    providedIn: 'root'
})
export class AlertService {

    //#region Global Variables
    confirmBtnClr: string = '#3085d6';
    cancelBtnClr: string = '#DC3545';
    //#endregion

    constructor() { }

    //#region Normal Alert Messages
    public showError(title: string, message: string, confirmButtonText: string) {
        var temp = 'error'
        return Swal.fire({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
            buttonsStyling: true,
            title: title,
            text: message,
            icon: 'error',
            confirmButtonText: confirmButtonText,
            confirmButtonColor: this.confirmBtnClr,
            cancelButtonColor: this.cancelBtnClr,
            allowEscapeKey: false,
            allowOutsideClick: false
        });
    }

    public showSuccess(title: string, message: string, confirmButtonText: string) {
        return Swal.fire({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
            buttonsStyling: true,
            title: title,
            text: message,
            icon: 'success',
            confirmButtonText: confirmButtonText,
            confirmButtonColor: this.confirmBtnClr,
            cancelButtonColor: this.cancelBtnClr,
            allowEscapeKey: false,
            allowOutsideClick: false
        });
    }

    public showWarning(title: string, message: string, confirmButtonText: string) {
        return Swal.fire({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
            buttonsStyling: true,
            title: title,
            text: message,
            icon: 'warning',
            confirmButtonText: confirmButtonText,
            confirmButtonColor: this.confirmBtnClr,
            cancelButtonColor: this.cancelBtnClr,
            allowEscapeKey: false,
            allowOutsideClick: false
        });
    }

    public showInfo(title: string, message: string, confirmButtonText: string) {
        return Swal.fire({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
            buttonsStyling: true,
            title: title,
            text: message,
            icon: 'info',
            confirmButtonText: confirmButtonText,
            confirmButtonColor: this.confirmBtnClr,
            cancelButtonColor: this.cancelBtnClr,
            allowEscapeKey: false,
            allowOutsideClick: false
        });
    }
    //#endregion

    //#region Async Alert Messages
    public async asyncShowError(title: string, message: string, confirmButtonText: string) {
        return await Swal.fire({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
            buttonsStyling: true,
            title: title,
            text: message,
            icon: 'error',
            confirmButtonText: confirmButtonText,
            confirmButtonColor: this.confirmBtnClr,
            cancelButtonColor: this.cancelBtnClr,
            allowEscapeKey: false,
            allowOutsideClick: false
        });
    }

    public async asyncShowSuccess(title: string, message: string, confirmButtonText: string) {
        return await Swal.fire({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
            buttonsStyling: true,
            title: title,
            text: message,
            icon: 'success',
            confirmButtonText: confirmButtonText,
            confirmButtonColor: this.confirmBtnClr,
            cancelButtonColor: this.cancelBtnClr,
            allowEscapeKey: false,
            allowOutsideClick: false
        });
    }

    public async asyncShowWarning(title: string, message: string, confirmButtonText: string) {
        return await Swal.fire({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
            buttonsStyling: true,
            title: title,
            text: message,
            icon: 'warning',
            confirmButtonText: confirmButtonText,
            confirmButtonColor: this.confirmBtnClr,
            cancelButtonColor: this.cancelBtnClr,
            allowEscapeKey: false,
            allowOutsideClick: false
        });
    }

    public async asyncshowInfo(title: string, message: string, confirmButtonText: string) {
        return await Swal.fire({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
            buttonsStyling: true,
            title: title,
            text: message,
            icon: 'info',
            confirmButtonText: confirmButtonText,
            confirmButtonColor: this.confirmBtnClr,
            cancelButtonColor: this.cancelBtnClr,
            allowEscapeKey: false,
            allowOutsideClick: false
        });
    }
    //#endregion

    //#region Async HTML Alert Messages
    public async showHmtlError(title: string, message: string, confirmButtonText: string) {
        return await Swal.fire({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
            buttonsStyling: true,
            title: title,
            html: message,
            icon: 'error',
            showCancelButton: true,
            confirmButtonText: confirmButtonText,
            confirmButtonColor: this.confirmBtnClr,
            cancelButtonColor: this.cancelBtnClr,
            allowEscapeKey: false,
            allowOutsideClick: false
        });
    }

    public async showHmtlSuccess(title: string, message: string, confirmButtonText: string) {
        return await Swal.fire({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
            buttonsStyling: true,
            title: title,
            html: message,
            icon: 'success',
            showCancelButton: true,
            confirmButtonText: confirmButtonText,
            confirmButtonColor: this.confirmBtnClr,
            cancelButtonColor: this.cancelBtnClr,
            allowEscapeKey: false,
            allowOutsideClick: false
        });
    }

    public async showHmtlWarning(title: string, message: string, confirmButtonText: string) {
        return await Swal.fire({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
            buttonsStyling: true,
            title: title,
            html: message,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: confirmButtonText,
            confirmButtonColor: this.confirmBtnClr,
            cancelButtonColor: this.cancelBtnClr,
            allowEscapeKey: false,
            allowOutsideClick: false
        });
    }

    public async showHmtlInfo(title: string, message: string, confirmButtonText: string) {
        return await Swal.fire({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
            buttonsStyling: true,
            title: title,
            html: message,
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: confirmButtonText,
            confirmButtonColor: this.confirmBtnClr,
            cancelButtonColor: this.cancelBtnClr,
            allowEscapeKey: false,
            allowOutsideClick: false
        });
    }
    //#endregion

    //#region User Confirmation Alerts

    // Normal Async User Confirmation Alert
    public async getUserConfirmation(title: string, message: string, confirmButtonText: string, cancelButtonText: string) {
        return await Swal.fire({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
            buttonsStyling: true,
            title: title,
            text: message,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText,
            confirmButtonColor: this.confirmBtnClr,
            cancelButtonColor: this.cancelBtnClr,
            allowEscapeKey: false,
            allowOutsideClick: false
        });
    }

    // HTML Async User Confirmation Alert
    public async getHtmlUserConfirmation(title: string, message: string, confirmButtonText: string, cancelButtonText: string, showCancelButton: boolean) {
        return await Swal.fire({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
            buttonsStyling: true,
            title: title,
            html: message,
            icon: 'warning',
            showCancelButton: showCancelButton,
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText,
            confirmButtonColor: this.confirmBtnClr,
            cancelButtonColor: this.cancelBtnClr,
            allowEscapeKey: false,
            allowOutsideClick: false
        });
    }
    //#endregion

}
